import { Injectable } from '@angular/core';
//****************************************************************
// Menu Class Descriptions
class menulist 
    {
        id: number = 0;
        text: string = '';
        icon: string = ''; 
    }   

export class menuitem
    {
        key: string = '';
        items: Array<menulist> | undefined;
        indexno: number | undefined;
        statusvisible: number | undefined;
        statusfullmenuvisible: number | undefined;
    }

// Menu Login Structure
let navigationloginmenu: menuitem[] = 
    [
        {   key: "Registration OR Login",
            indexno: 0,
            statusvisible:0,                    // Menu structure Identification
            statusfullmenuvisible: 0,
            items:  [
                        { id: 10, text: "Register",    icon: "fa-solid fa-registered" },
                        { id: 20, text: "Login ",      icon: "fa-solid fa-right-to-bracket" }          
                    ]
        }   

    ]

// Menu Structure
let navigationmenu: menuitem[] = 
    [

        {   key: "Participant and Event Profile",
            indexno: 0,
            statusvisible:1,   
            statusfullmenuvisible: 10,
            items:  [
                        { id: 100, text: "+Set Profiles", icon: "fas fa-search-dollar" } 
                    ]
        },

        {   key: "Event Invitee",
            indexno: 1,
            statusvisible:5,  
            statusfullmenuvisible: 10,
            items:  [
                        { id: 200, text: "+Names+Address+Contact Details+Dietary", icon: "fas fa-search-dollar"    },
                        { id: 210, text: "+Invitation Delivery Register", icon: ""    }, 
                        { id: 220, text: "+Gift Register/Gifts Received", icon: ""    },  
                        { id: 230, text: "+Invitee Undecided/Coming/Not Coming", icon: ""    }, 
                        { id: 240, text: "+Seating Arrangements", icon: ""    },   
                        { id: 250, text: "+Gifts and Thankyou", icon: ""    }                
                    ]
        },

        {   key: "Event To Do",
            indexno: 2,
            statusvisible:5,  
            statusfullmenuvisible: 10,
            items:  [
                        { id: 300, text: "To Do List", icon: ""    }     
                    ]
        },

        {   key: "Event Appointments",
            indexno: 3,
            statusvisible:5,  
            statusfullmenuvisible: 10,
            items:  [
                        { id: 400, text: "Appointments", icon: "fas fa-users-cog"     }, 
                    ]
        },

        {   key: "Event Finances",
            indexno: 4,
            statusvisible:5,  
            statusfullmenuvisible: 10,
            items:  [
                        { id: 450, text: "Financial Status", icon: "fas fa-users-cog"     }, 
                    ]
        },

        {   key: "Event Dashboards",
            indexno: 5,
            statusvisible:5, 
            statusfullmenuvisible: 10, 
            items:  [
                        { id: 500, text: "+Invitees", icon: "fas fa-users-cog"     },
                        { id: 510, text: "To Do ", icon: ""    },
                        { id: 515, text: "Appointments ", icon: ""    },
                        { id: 520, text: "Finances ", icon: ""    },
                       
                    ]
        },

        {   key: "Event Reports",
            indexno: 6,
            statusvisible:5,  
            statusfullmenuvisible: 10,
            items:  [
                        { id: 600, text: "Invitees Profiles", icon: ""     },
                        { id: 610, text: "Invitation Profiles ", icon: ""    },
                        { id: 620, text: "Gift Profile ", icon: ""    },
                        { id: 630, text: "Seating Arrangements ", icon: ""    },
                    
                    ]
        }
        

    ]

// Administration - Menu Array
let navigationshortadmin: menuitem[] = 
    [
      
        { key: "Administration",
            indexno: 0,
            statusvisible:1,  
            statusfullmenuvisible: 10,
            items:  [
                        { id: 1000, text: "FAQ Maintenance", icon: "fas fa-question-circle" } ,
                        { id: 1010, text: "Spare Menu",      icon: "fas fa-question-circle" } ,
                        { id: 1020, text: "Spare Menu",      icon: "fas fa-question-circle" }     
                    ]
        }

    ]

//****************************************************************
// Invitee Titles
let titlelist: string[] =
    [
        "Mr",
        "Mrs",
        "Ms",
        "Miss",
        "Mx",
        "Master"
    ];

// Diet Categories
let dietlist: string[] =
    [
        "No Dietary Restriction",
        "Vegetarian",
        "Pescatarian",
        "Vegan",
        "Paleo",
        "Flexitarian",
        "Other"
    ];

// Collaborators Status List
let collaboratorstatuslist: string[] =
    [
        "Listed",
        "Shortlist",
        "Confirm"
    ];

// Zoom Listing
let zoomlist: string[] =
    [
        "25",
        "50",
        "75",
        "100",
        "125",
        "150",
        "200"
    ]
//****************************************************************
// Document Category
export class category 
    {
        id: number = 0;
        categorydesc: string = '';
        categoryfname: string = '';
        chargerateid: number = 0;   // Percentage Administration Fee - Percentage
    }   

let categorylist: category[] = 
    [
        { id: 10, categorydesc: "Building Report",          categoryfname: "Building_Report",               chargerateid: 20    },
        { id: 20, categorydesc: "Pest Report",              categoryfname: "Pest_Report",                   chargerateid: 20    },
        { id: 30, categorydesc: "Strata Report",            categoryfname: "Strata_Report",                 chargerateid: 20    },
        { id: 40, categorydesc: "Easement Report",          categoryfname: "Easement_Report",               chargerateid: 20    },
        { id: 50, categorydesc: "Drainage Report",          categoryfname: "Drainage_Report",               chargerateid: 20    },
        { id: 60, categorydesc: "Health & Safety Report",   categoryfname: "HealthSafety_Report",           chargerateid: 20    }
    ];
//****************************************************************
// Login Options
export class logininfo 
    {
        id: number = 0;
        logindesc: string = '';
        category: string = '';
    }   

let loginlist: logininfo[] = 
    [
        { id: 10, logindesc: "REGISTER",            category: "Sale of Documents" },
        { id: 15, logindesc: "LOGIN",               category: "Sale of Documents" },
        { id: 18, logindesc: "RESET PASSWORD",      category: "Sale of Documents" },
        { id: 20, logindesc: "REGISTER",            category: "Team up for Documents" },
        { id: 25, logindesc: "LOGIN",               category: "Team up for Documents" },
        { id: 28, logindesc: "RESET PASSWORD",      category: "Team up for Documents" }
    ];
//****************************************************************
export class servicecharge 
    {
        id: number = 0;
        chargerate: number = 0;
    }   

let servicechargerate: servicecharge[] = 
    [
        { id: 10, chargerate: 10  },
        { id: 15, chargerate: 15  },
        { id: 20, chargerate: 20  },
        { id: 25, chargerate: 25  },
        { id: 30, chargerate: 30  },
        { id: 35, chargerate: 35  }
    ];
//****************************************************************
@Injectable()

export class liststructures
    {
        //****************************************************************
        getmenuLoginList(): menuitem[] 
            {
                return navigationloginmenu;
            }


        getmenuList(): menuitem[] 
            {
                return navigationmenu;
            }

        // Administration Menu    
        getmenuListAdmin(): menuitem[] 
            {
                return navigationshortadmin;
            }
        
       // getmenuLoginList(): logininfo[] 
       //     {
       //         return loginlist;
        //    }
        //****************************************************************
        // Invitee Title
        getTitle()
            {
                return titlelist;
            }   
        //****************************************************************
        // Dietary 
        getDietary()
            {
                return dietlist;
            }   
        //****************************************************************
        getzoomList(): string[]
            {
                return zoomlist;
            }
        //****************************************************************
        getdoccategoryList(): category[]
            {
                return categorylist;
            }
        //****************************************************************
        getservicecharge(): servicecharge[]
        {
            return servicechargerate;
        }
        //****************************************************************
        // Collaborators
        getcollaboratorstatus()
            {
                return collaboratorstatuslist;   
            }

        //****************************************************************
    }
//****************************************************************